<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Aguarde :show="httpSend"></Aguarde>
    <div class="row">
      <div class="col-12 mb-2">
        <button type="button" @click="baixar_nota()" class="btn btn-label mr-3 btn-success">
          <i class="bx bxs-download label-icon"></i> Baixar PDF
        </button>
        <button type="button" @click="baixar_xml()" class="btn btn-label mr-3 btn-info">
          <i class="bx bxs-file-css label-icon"></i> Baixar XML
        </button>
        <router-link
            class="btn btn-label btn-outline-dark mr-3"
            tag="a"
            href="javascript: void(0);"
            to="/contribuinte/nota-fiscal/lista">
          <i class="bx bx-detail label-icon"></i>
          Lista de Notas
        </router-link>
        <router-link
            class="btn btn-label btn-outline-primary"
            tag="a"
            href="javascript: void(0);"
            to="/contribuinte/nota-fiscal/gerar">
          <i class="bx bx-plus label-icon"></i>
          Nova Nota
        </router-link>
      </div>
      <div class="col-12">
        <div class="card p-3">
          <embed :src="link_nota" style="width:100%; height:120em;" type="text/html">
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import Aguarde from "@/components/widgets/aguarde";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import {urlTemp} from "@/helps/impressao";
import {setRelNotaFiscal} from "@/api/relatorio/nota_fiscal";
import {downloadNota, downloadNotaXML} from "@/api/nfse/nota";

export default {
  page: {
    title: "Notas Fiscais",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Aguarde
  },
  data() {
    return {
      title: "Notas Fiscais",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Nota Fiscal',
          href: '/painel',
        },
        {
          text: 'Visualizar',
          active: true,
        },
      ],
      link_nota: '',
      httpSend: false,
    };
  },
  created() {
    this.httpSend = true;
    urlTemp(setRelNotaFiscal(this.$route.params.not_hash)).then(result => {
      this.link_nota = result;
    }).catch(error => {
      console.log(error)
    }).finally(() => {
      this.httpSend = false;
    })
  },
  methods: {
    baixar_nota() {
      this.httpSend = true;
      downloadNota(this.$route.params.not_hash).then(result => {
        if (result.status) {
          window.open(result.mensagem, '_blank');
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    baixar_xml() {
      this.httpSend = true;
      downloadNotaXML(this.$route.params.not_hash).then(result => {
        if (result.status) {
          window.open(result.mensagem, '_blank');
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
  },
};
</script>


